import restArguments from './restArguments.js';
import unzip from './unzip.js';

// Zip together multiple lists into a single array -- elements that share
// an index go together.
export default restArguments(unzip);



//////////////////
// WEBPACK FOOTER
// ./node_modules/backbone/node_modules/underscore/modules/zip.js
// module id = 290
// module chunks = 0